import CSRFTokenResolver from "../global/CSRFTokenResolver";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";
import SplitType from "split-type";
import imagesLoaded from 'imagesloaded';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '2f56877bc7388f6893bf',
    cluster: 'eu',
    encrypted: true,
    namespace: 'Modules.Member.Events.LiveChat'
});

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': CSRFTokenResolver.getToken(),
    'X-Requested-With': 'XMLHttpRequest'
};

window.Echo.connector.pusher.connection.bind('connected', function () {
    window.axios.defaults.headers.common['X-Socket-ID'] = window.Echo.socketId();
});

// RENDERER
var loadingManager = new THREE.LoadingManager();

// $(document).ready(function() {
    var primaryColour = $('#primary_colour').val();
    var secondaryColour = $('#secondary_colour').val();
    var accentColour = $('#accent_colour').val();
    var floorColour = $('#floor_colour').val();
    var hotspotColour = $('#hotspot_colour').val();
    var bannerURL = $('#banner_url').val();
    var banner2URL = $('#banner2_url').val();
    var postersURLs = $('#poster_urls').val();
    var bookStandBook1URLs = $('#book_stand_url').val();
    var screenUrl = $('#screen_url').val();
    var logoURL = $('#logo_url').val();
    var logoURL2 = $('#logo2_url').val();

    let objectCir;
    let objectCir2;
    let objectCir3;
    let objectCir4;
    let objectCir5;
    let objectCir6;
    let objectCir7;
    let objectCir8;
    let vLine;
    let hLine;
    let vLine2;
    let hLine2;
    let vLine3;
    let hLine3;
    let vLine4;
    let hLine4;
    let vLine5;
    let hLine5;
    let vLine6;
    let hLine6;
    let vLine7;
    let hLine7;
    let vLine8;
    let hLine8;
    let hotspotGroup;
    let hotspotGroup2;
    let hotspotGroup3;
    let hotspotGroup4;
    let hotspotGroup5;
    let hotspotGroup6;
    let hotspotGroup7;
    let hotspotGroup8;

    var postersPopup = document.getElementById('posters');
    var jobsPopup = document.getElementById('jobs');

    if (typeof postersURLs !== typeof undefined) {
        postersURLs = postersURLs.replace(' ', '');
        postersURLs = postersURLs.split(',');
    }

    const canvas = document.getElementById('stand');
    let renderer;
    if (canvas) {
        // RENDERER
        renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true,
            canvas: canvas,
            powerPreference: "high-performance"
        });
    } else {
        // RENDERER
        renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true,
            powerPreference: "high-performance"
        });

        let container = document.getElementsByClassName('exhibitions-home');
        if (container.length > 0) {
            container[0].prepend(renderer.domElement);
        } else {
            document.body.prepend(renderer.domElement);
        }
    }

    const isMicrositeBoothPage = (document.getElementsByClassName('microsite').length > 0) ? true : false;

    let width = window.innerWidth,
        height = window.innerHeight;

    if (isMicrositeBoothPage) {
        height = window.innerHeight - 112;
    }

    renderer.setClearColor(0xe5e5e5);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(width, height);
    renderer.shadowMap.enabled = true;
    renderer.physicallyCorrectLights = false;
    // renderer.shadowMap.type = THREE.PCFShadowMap; // THREE.PCFSoftShadowMap
    renderer.shadowMap.type = THREE.VSMShadowMap;
    // renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    // renderer.toneMapping = THREE.ACESFilmicToneMapping;
    // renderer.toneMapping = THREE.NoToneMapping;
    renderer.toneMapping = THREE.LinearToneMapping;
    // renderer.toneMapping = THREE.ReinhardToneMapping;
    // renderer.toneMapping = THREE.Uncharted2ToneMapping;
    // renderer.toneMapping = THREE.CineonToneMapping;
    // renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 0.5;
    // renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.outputEncoding = THREE.LinearEncoding;
    THREE.Cache.enabled = true;

    const textureLoader = new THREE.TextureLoader(loadingManager);
    textureLoader.mapping = THREE.sRGBEncoding;

    // CAMERA
    // let camera = new THREE.PerspectiveCamera(29.979213154087123, 1.6666666269302368, 0.009999999776482582, 10000000000);
    let camera = new THREE.PerspectiveCamera(25, width / height, 0.009999999776482582, 10000);

    camera.position.x = 0;
    camera.position.y = 2;
    camera.position.z = 15;

    // SCENE
    const scene = new THREE.Scene();
    textureLoader.load('/images/model-background.jpg', function(texture) {
        scene.background = texture;
    });

    // LIGHTS
    const lightAmbient = new THREE.AmbientLight(0xffffff, 0.625);
    const lightHemisphere = new THREE.HemisphereLight(0xFFFFFF, 0xF0CDCD, 0.35);
    const lightDirectional = new THREE.DirectionalLight(0xffffff, 0.5);
    const lightDirectional2 = new THREE.DirectionalLight(0xffffff, 0.5);
    const lightDirectional3 = new THREE.DirectionalLight(0xffffff, 0.5);
    // const lightPoint = new THREE.PointLight( 0xffffff, 1, 10 );

    // lightPoint.position.set(0.25, 1.35, 0.25);

    lightDirectional.castShadow = true;
    lightDirectional2.castShadow = true;
    lightDirectional3.castShadow = true;

    // lightDirectional.position.set(4.8394, 5.2332, 8.7907);
    lightDirectional.position.set(0, 1.5, 3.5);
    lightDirectional2.position.set(-4.8394, 4.25, 3.5);
    lightDirectional3.position.set(0.021861, 4.25, 5);

    // scene.add( new THREE.CameraHelper( lightDirectional.shadow.camera ) );
    // scene.add( new THREE.CameraHelper( lightDirectional2.shadow.camera ) );
    // scene.add( new THREE.CameraHelper( lightDirectional3.shadow.camera ) );

    lightHemisphere.position.set(0, 0.25, 10);

    // ADD LIGHTS TO THE SCENE
    // scene.add(lightPoint);
    scene.add(lightAmbient);
    scene.add(lightHemisphere);
    scene.add(lightDirectional);
    scene.add(lightDirectional2);
    scene.add(lightDirectional3);

    let controls = new THREE.OrbitControls(camera, renderer.domElement);

    function render() {
        if (objectCir) {
            objectCir.rotation.y = controls.getAzimuthalAngle();
        }

        if (vLine) {
            vLine.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine) {
            hLine.rotation.y = controls.getAzimuthalAngle();
        }

        if (objectCir2) {
            objectCir2.rotation.y = controls.getAzimuthalAngle();
        }

        if (vLine2) {
            vLine2.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine2) {
            hLine2.rotation.y = controls.getAzimuthalAngle();
        }

        if (objectCir3) {
            objectCir3.rotation.y = controls.getAzimuthalAngle();
        }

        if (vLine3) {
            vLine3.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine3) {
            hLine3.rotation.y = controls.getAzimuthalAngle();
        }

        if (objectCir4) {
            objectCir4.rotation.y = controls.getAzimuthalAngle();
        }

        if (vLine4) {
            vLine4.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine4) {
            hLine4.rotation.y = controls.getAzimuthalAngle();
        }

        if (objectCir5) {
            objectCir5.rotation.y = controls.getAzimuthalAngle();
        }

        if (vLine5) {
            vLine5.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine5) {
            hLine5.rotation.y = controls.getAzimuthalAngle();
        }

        if (objectCir6) {
            objectCir6.rotation.y = controls.getAzimuthalAngle();
        }

        if (vLine6) {
            vLine6.rotation.y = controls.getAzimuthalAngle();
        }

        if (hLine6) {
            hLine6.rotation.y = controls.getAzimuthalAngle();
        }

        if (postersPopup) {
            if (objectCir7) {
                objectCir7.rotation.y = controls.getAzimuthalAngle();
            }
    
            if (vLine7) {
                vLine7.rotation.y = controls.getAzimuthalAngle();
            }
    
            if (hLine7) {
                hLine7.rotation.y = controls.getAzimuthalAngle();
            }
        }
        
        if (jobsPopup) {
            if (objectCir8) {
                objectCir8.rotation.y = controls.getAzimuthalAngle();
            }
    
            if (vLine8) {
                vLine8.rotation.y = controls.getAzimuthalAngle();
            }
    
            if (hLine8) {
                hLine8.rotation.y = controls.getAzimuthalAngle();
            }
        }
    }

    controls.enabled = true;
    controls.enablePan = true;
    // controls.target.set(0, 1.75, -2);
    // controls.target.set(-1.35, 2, 2);
    // controls.target.set( 0, 1.75, -0.2 );
    controls.target.set( 0, 1.75, -0.2 );
    // controls.minDistance = 10;
    controls.maxDistance = 20;
    controls.rotateSpeed = 0.75;
    controls.zoomSpeed = 0.75;
    controls.maxPolarAngle = Math.PI / 2;
    controls.minPolarAngle = Math.PI / 2;
    // controls.maxAzimuthAngle = -0.013094791152698045;
    controls.minAzimuthAngle = -0.75033688229047272;
    controls.maxAzimuthAngle = 0.07139983303613207;
    // controls.maxAzimuthAngle = -0.5033688229047272;

    controls.update();

    controls.addEventListener('change', render, false);

    const loader = new GLTFLoader(loadingManager);

    // let spotLightsPositions = [
    //     [0.2525, 2.025, 0.64], [0.285, 2.025, 1.5255], 
    //     [1.435, 2.03, 1.455], [1.4, 2.03, 0.576], [1.379555, 2.03, -0.3025], 
    //     [0.421225, 1.895, -0.55999], [-0.245, 1.89295, -0.552], 
    //     [-1.265, 2.975, -0.999], [-1.7875, 2.975, -0.975], [-1.8125, 2.975, -1.612]
    // ];

    // let spotLightsPositions = [
    //     [0.2525, 2, 0.64], [0.285, 2, 1.5255], 
    //     [1.435, 2, 1.455], [1.4, 2, 0.576], [1.379555, 2, -0.3025], 
    //     [0.421225, 1.89, -0.55999], [-0.245, 1.89, -0.552], 
    //     [-1.265, 2.96999, -0.999], [-1.7875, 2.96999, -0.975], [-1.8125, 2.96999, -1.612]
    // ];

    const interaction = new THREE.Interaction(renderer, scene, camera);
    loader.load('/js/exhibitions/models/gold-stand.glb', function (gltf) {

        for (var i = 0; i < gltf.scene.children.length; i++) {
            gltf.scene.children[i].castShadow = true;

            if (gltf.scene.children[i].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                }
            }));

            if (gltf.scene.children[i].children.length > 0) {
                for (var j = 0; j < gltf.scene.children[i].children.length; j++) {
                    gltf.scene.children[i].children[j].castShadow = true;
                    gltf.scene.children[i].children[j].receiveShadow = true;
                    
                    if (gltf.scene.children[i].children[j].traverse(function (child) {
                        if (child.isMesh) {
                            child.material.color = new THREE.Color(secondaryColour);
                        }
                    }));
                    
                    if (gltf.scene.children[i].children[j].children.length > 0) {
                        if (secondaryColour) {
                            if (gltf.scene.children[i].children[j].traverse(function (child) {
                                if (child.isMesh) {
                                    child.material.color = new THREE.Color(secondaryColour);
                                }
                            }));
                        }
                        
                        for (var k = 0; k < gltf.scene.children[i].children[j].children.length; k++) {
                            gltf.scene.children[i].children[j].children[k].receiveShadow = true;
                            gltf.scene.children[i].children[j].children[k].castShadow = true;
                            
                            if (gltf.scene.children[i].children[j].children[k].traverse(function (child) {
                                if (child.isMesh) {
                                    child.material.color = new THREE.Color(secondaryColour);
                                }
                            }));
                            
                            if (gltf.scene.children[i].children[j].children[k].children.length > 0) {
                                
                                for (var l = 0; l < gltf.scene.children[i].children[j].children[k].children.length; l++) {
                                    gltf.scene.children[i].children[j].children[k].children[l].receiveShadow = true;
                                    gltf.scene.children[i].children[j].children[k].children[l].castShadow = true;
                                    
                                    if (gltf.scene.children[i].children[j].children[k].children[l].traverse(function (child) {
                                        if (child.isMesh) {
                                            child.material.color = new THREE.Color(secondaryColour);
                                        }
                                    }));
                                    
                                    if (gltf.scene.children[i].children[j].children[k].children[l].children.length > 0) {
                                        for (var m = 0; m < gltf.scene.children[i].children[j].children[k].children[l].children.length; m++) {
                                            gltf.scene.children[i].children[j].children[k].children[l].children[m].receiveShadow = true;
                                            gltf.scene.children[i].children[j].children[k].children[l].children[m].castShadow = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        // let index = 0;
        // for (var x = 0; x < spotLightsPositions.length; x++) {
        //     let spotLight = new THREE.SpotLight(0xffffff);
        //     spotLight.intensity = 0.25;
        //     // let spotLight = new THREE.SpotLight(0xffffff, 10, 2.5, 0.2);
        //     spotLight.position.set(spotLightsPositions[index][0], spotLightsPositions[index][1], spotLightsPositions[index][2]);
        //     spotLight.castShadow = false;
        //     let object3D = new THREE.Object3D();
        //     object3D.position.set(spotLightsPositions[index][0], 0, spotLightsPositions[index][2]);
        //     scene.add(object3D);
        //     // let helper = new THREE.SpotLightHelper(spotLight);
        //     // let helper = new THREE.DirectionalLightHelper(spotLight);
        //     spotLight.target = object3D;
        //     // let pointLight = new THREE.PointLight(0xffffff, 1, 5, 2, 2);
        //     // pointLight.position.set(spotLightsPositions[index][0], spotLightsPositions[index][1] - 0.25, spotLightsPositions[index][2])
        //     scene.add(spotLight);
        //     scene.add(spotLight.target);
        //     // scene.add(pointLight);
        //     // scene.add(helper);
        //     index++;
        // }

        if (bannerURL && bannerURL !== undefined && bannerURL !== '') {
            textureLoader.load(
                bannerURL,
                function (texture) {
                    if (gltf.scene.children[0].children[0].children[0].traverse(function (child) {
                        if (child.isMesh) {
                            child.material = new THREE.MeshPhysicalMaterial({color: 0xffffff, map: texture});
                        }
                    }));

                    // if (gltf.scene.children[0].children[1].children[0].traverse(function (child) {
                    //     if (child.isMesh) {
                    //         child.material = new THREE.MeshPhysicalMaterial({color: 0xffffff, map: texture});
                    //     }
                    // }));
                }
            );
        }

        if (banner2URL && banner2URL !== undefined && banner2URL !== '') {
            textureLoader.load(
                banner2URL,
                function (texture) {
                    // if (gltf.scene.children[0].children[0].children[0].traverse(function (child) {
                    //     if (child.isMesh) {
                    //         child.material = new THREE.MeshPhysicalMaterial({color: 0xffffff, map: texture});
                    //     }
                    // }));

                    if (gltf.scene.children[0].children[1].children[0].traverse(function (child) {
                        if (child.isMesh) {
                            child.material = new THREE.MeshPhysicalMaterial({color: 0xffffff, map: texture});
                        }
                    }));
                }
            );
        } else {
            textureLoader.load(
                bannerURL,
                function (texture) {
                    if (gltf.scene.children[0].children[1].children[0].traverse(function (child) {
                        if (child.isMesh) {
                            child.material = new THREE.MeshPhysicalMaterial({color: 0xffffff, map: texture});
                        }
                    }));
                }
            );
        }

        if (primaryColour) {
            // Railings
            if (gltf.scene.children[0].children[4].children[1].children[0].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(primaryColour);
                    child.material.transparent = true;
                    child.material.opacity = 0.25;
                    child.receiveShadow = false;
                    child.castShadow = false;
                }
            }));

            // Top Roof
            if (gltf.scene.children[0].children[4].children[13].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(primaryColour);
                }
            }));

            if (gltf.scene.children[0].children[4].children[8].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(primaryColour);
                }
            }));
        }

        if (accentColour) {
            if (gltf.scene.children[0].children[4].children[6].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(accentColour);
                }
            }));

            // Booklet on the desk
            if (gltf.scene.children[0].children[5].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshLambertMaterial({color: accentColour});
                    child.receiveShadow = false;
                    child.castShadow = false;
                }
            }));

            // Booklet on the desk
            if (gltf.scene.children[0].children[6].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshLambertMaterial({color: accentColour});
                    child.receiveShadow = false;
                    child.castShadow = false;
                }
            }));

            // Inset Roof Top
            if (gltf.scene.children[0].children[4].children[6].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshLambertMaterial({color: accentColour});
                    child.receiveShadow = false;
                    child.castShadow = false;
                }
            }));

            // Bar chairs
            for (let i = 1; i < 4; i++) {
                if (gltf.scene.children[0].children[3].children[0].children[i].traverse(function (child) {
                    if (child.isMesh) {
                        child.material = new THREE.MeshPhysicalMaterial({color: 0xe0e2e3});
                    }
                }));
            }

            // Desk Inner
            if (gltf.scene.children[0].children[3].children[3].children[1].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: accentColour});
                }
            }));
        }
        
        // Spotlights
        if (gltf.scene.children[0].children[4].children[2].children.length > 0) {
            for (let x = 0; x < gltf.scene.children[0].children[4].children[2].children.length; x++) {
                gltf.scene.children[0].children[4].children[2].children[x].castShadow = false;
                gltf.scene.children[0].children[4].children[2].children[x].receiveShadow = false;
            }
        }
        // Spotlights
        if (gltf.scene.children[0].children[4].children[2].traverse(function (child) {
            if (child.isMesh) {
                child.material = new THREE.MeshLambertMaterial({color: 0xffffff});
                child.receiveShadow = false;
                child.castShadow = false;
            }
        }));
        
        if (floorColour) {
            // First Floor and Second Floor Carpet
            if (gltf.scene.children[0].children[4].children[0].children[0].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(floorColour);
                    child.receiveShadow = false;
                    child.castShadow = false;
                }
            }));
        
            if (gltf.scene.children[0].children[4].children[0].children[1].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(floorColour);
                    child.receiveShadow = false;
                    child.castShadow = false;
                }
            }));
        }
        
        // Logo
        gltf.scene.children[0].children[11].castShadow = false;
        gltf.scene.children[0].children[11].receiveShadow = false;
        if (gltf.scene.children[0].children[11].traverse(function (child) {
            if (child.isMesh) {
                textureLoader.load(logoURL2, function(texture) {
                    var logoRight = new THREE.Mesh(new BoxGeometry(1.3945216182482851, 0.5350062310745143, 0.06691782794729129), new THREE.MeshPhysicalMaterial({color: 0xffffff, map: texture}));
                    // logoRight.position.set(0.5940560299845515, 3.099622706797363, 1.9381666714450394);
                    // logoRight.position.set(1.29131683911, 3.36712582233, 1.97162558542);
                    logoRight.position.set(1.29131683911, 3.36712582233, 1.9523522552558542);
                    logoRight.rotation.y = 0.03675;
                    scene.add(logoRight);

                    // var box = new THREE.Box3().setFromObject( child );
                    // console.log( box.min, box.max, box.getSize() );

                    // child.material = new THREE.MeshPhysicalMaterial({color: 0xffffff, map: texture, transparent: true, opacity: 1});
                    // child.material = new THREE.MeshPhysicalMaterial({color: 0xffffff, map: texture});
                });
            }
        }));

        // let logoBox = new THREE.Mesh(new THREE.BoxBufferGeometry(1.40, 0.5375, 0.02), new THREE.MeshPhysicalMaterial({color: 0xff00ff, transparent: true, opacity: 0.5}));
        // logoBox.position.set(1.2875, 3.375, 2);
        // scene.add(logoBox);
        
        // Logo
        gltf.scene.children[0].children[10].castShadow = false;
        gltf.scene.children[0].children[10].receiveShadow = false;
        if (gltf.scene.children[0].children[10].traverse(function (child) {
            if (child.isMesh) {
                textureLoader.load(logoURL, function(texture) {
                    child.material = new THREE.MeshPhysicalMaterial({color: 0xffffff, map: texture});
                });
            }
        }));
        
        if (secondaryColour) {
            // Curved Panel
            if (gltf.scene.children[0].children[4].children[5].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                }
            }));

            // Main Body
            gltf.scene.children[0].children[4].children[10].castShadow = false;
            gltf.scene.children[0].children[4].children[10].receiveShadow = false;
            if (gltf.scene.children[0].children[4].children[10].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                }
            }));
            
            if (gltf.scene.children[0].children[4].children[9].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                }
            }));
            
            if (gltf.scene.children[0].children[4].children[14].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                    // child.material.color = new THREE.Color(secondaryColour);
                }
            }));
            
            if (gltf.scene.children[0].children[4].children[5].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                    // child.material.color = new THREE.Color(secondaryColour);
                }
            }));
            
            // Ceiling
            if (gltf.scene.children[0].children[7].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                    child.receiveShadow = false;
                }
            }));
            
            // Inset Roof bottom
            if (gltf.scene.children[0].children[4].children[7].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                    // child.material.color = new THREE.Color(secondaryColour);
                }
            }));

            // Book Stand
            for (let i = 0; i < 3; i++) {
                if (gltf.scene.children[0].children[2].children[1].children[i].traverse(function (child) {
                    if (child.isMesh) {
                        child.material.color = new THREE.Color(0xeeeeee);
                    }
                }));
            }

            // First floor tv backwall
            if (gltf.scene.children[0].children[4].children[4].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                }
            }));

            // First Floor TV Frame
            if (gltf.scene.children[0].children[3].children[9].children[1].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(0xdddddd);
                }
            }));

            // Chairs and tables
            if (gltf.scene.children[0].children[3].children[6].children[3].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: 0xf3f2f0});
                }
            }));
            
            // Chairs and tables
            if (gltf.scene.children[0].children[3].children[7].children[3].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: 0xf3f2f0});
                }
            }));
            
            // Desk Outer
            if (gltf.scene.children[0].children[3].children[3].children[0].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: secondaryColour});
                }
            }));
            
            // Bar table
            if (gltf.scene.children[0].children[3].children[0].children[0].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: secondaryColour});
                }
            }));

            // Curved Panel
            if (gltf.scene.children[0].children[4].children[5].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                }
            }));

            // Main Body
            if (gltf.scene.children[0].children[4].children[10].traverse(function (child) {
                if (child.isMesh) {
                    child.material.color = new THREE.Color(secondaryColour);
                }
            }));
            
            if (gltf.scene.children[0].children[4].children[9].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshLambertMaterial({color: secondaryColour});
                }
            }));
            
            if (gltf.scene.children[0].children[4].children[14].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: secondaryColour});
                    // child.material.color = new THREE.Color(secondaryColour);
                }
            }));
            
            if (gltf.scene.children[0].children[4].children[5].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: secondaryColour});
                    // child.material.color = new THREE.Color(secondaryColour);
                }
            }));
            
            // Ceiling
            if (gltf.scene.children[0].children[7].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: secondaryColour});
                    child.receiveShadow = false;
                }
            }));
            
            // Inset Roof bottom
            if (gltf.scene.children[0].children[4].children[7].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: secondaryColour});
                    // child.material.color = new THREE.Color(secondaryColour);
                }
            }));

            // Book Stand
            for (let i = 0; i < 3; i++) {
                if (gltf.scene.children[0].children[2].children[1].children[i].traverse(function (child) {
                    if (child.isMesh) {
                        child.material = new THREE.MeshLambertMaterial({color: 0xeeeeee});
                    }
                }));
            }

            // First floor tv backwall
            if (gltf.scene.children[0].children[4].children[4].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: secondaryColour});
                }
            }));

            // First Floor TV Frame
            if (gltf.scene.children[0].children[3].children[9].children[1].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: 0xdddddd});
                }
            }));

            // Chairs and tables
            if (gltf.scene.children[0].children[3].children[6].children[3].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: 0xf3f2f0});
                }
            }));
            
            // Chairs and tables
            if (gltf.scene.children[0].children[3].children[7].children[3].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: 0xf3f2f0});
                }
            }));
            
            // Desk Outer
            if (gltf.scene.children[0].children[3].children[3].children[0].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: secondaryColour});
                }
            }));
            
            // Bar table
            if (gltf.scene.children[0].children[3].children[0].children[0].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhysicalMaterial({color: secondaryColour});
                }
            }));
        }
        
        // if (gltf.scene.children[0].children[4].children[4].traverse(function (child) {
        //     if (child.isMesh) {
        //         child.material = new THREE.MeshLambertMaterial({color: 0xffff00});
        //         // child.material.color = new THREE.Color(0xffffff);
        //         // child.receiveShadow = false;
        //         // child.castShadow = false;
        //     }
        // }));

        if (bookStandBook1URLs) {
            if (gltf.scene.children[0].children[2].children[0].children.length > 0) {
                for (let y = 0; y < gltf.scene.children[0].children[2].children[0].children.length; y++) {
                    if (gltf.scene.children[0].children[2].children[0].children[y].traverse(function (child) {
                        if (child.isMesh) {
                            textureLoader.load(bookStandBook1URLs, function(texture) {
                                child.material = new THREE.MeshPhysicalMaterial({color: 0xffffff, map: texture});
                                child.receiveShadow = false;
                                child.castShadow = false;
                            });
                        }
                    }));
                }
            }
        }

        // if (gltf.scene.children[0].children[1].children[0].children[0].traverse(function (child) {
        //     if (child.isMesh) {
        //         new THREE.TextureLoader().load(bookStandBook1URLs[0], function(texture) {
        //             child.material = new THREE.MeshLambertMaterial({color: 0xffffff, map: texture});
        //             child.receiveShadow = false;
        //             child.castShadow = false;
        //         });
        //     }
        // }));

        // Poster Bottom
        for (let x = 0; x < 2; x++) {
            var posterTexutre = textureLoader.load(postersURLs[x]);
            let poster = new THREE.Mesh(new THREE.BoxGeometry(0.555, 0.8375, 0.025), new THREE.MeshPhysicalMaterial({color: 0xffffff, map: posterTexutre}));
            if (x === 0) {
                poster.position.set(-1.83025, 1.098125, -1.92475);
            } else {
                poster.position.set(-1.83025, 2, -1.92475);
            }
            poster.rotation.y = 0.0375;
            scene.add(poster);
        }
        
        if (gltf.scene.children[0].children[4].children[5].traverse(function (child) {
            if (child.isMesh) {
                child.material = new THREE.MeshLambertMaterial({color: 0xdddddd});
                // child.receiveShadow = false;
                // child.castShadow = false;
            }
        }));

        if (screenUrl) {
            var tvWallpaper = textureLoader.load(screenUrl);

            if (gltf.scene.children[0].children[3].children[8].children[3].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhongMaterial({
                        color: 0xffffff
                    });
                }
            }));

            var topTV = new THREE.Mesh(new THREE.BoxGeometry(0.7494750558365462, 0.46287256871366234, 0.017), new THREE.MeshPhysicalMaterial({color: 0xffffff, map: tvWallpaper}));
            topTV.position.set(0.283575, 3.25875, -1.325);
            topTV.rotation.y = 0.03675;
            topTV.receiveShadow = true;
            topTV.castShadow = false;

            scene.add(topTV);

            if (gltf.scene.children[0].children[3].children[9].children[0].traverse(function (child) {
                if (child.isMesh) {
                    child.material = new THREE.MeshPhongMaterial({
                        color: 0xffffff
                    });
                }
            }));

            var bottomTV = new THREE.Mesh(new THREE.BoxGeometry(1.2324276515096762, 0.5921022357466126, 0.045861885538533764), new THREE.MeshPhysicalMaterial({color: 0xffffff, map: tvWallpaper}));
            bottomTV.position.set(0.155, 1.4, -1.2675);
            bottomTV.rotation.y = 0.03675;
            bottomTV.receiveShadow = true;
            bottomTV.castShadow = false;

            scene.add(bottomTV);
        }

        scene.add(gltf.scene);

    }, function (progress) {
        if (progress.loaded === progress.total) {
            // var geometryRing = new THREE.RingGeometry( 0.12, 0.16, 32 );
            // var materialRing = new THREE.MeshBasicMaterial( { color: accentColor, side: THREE.DoubleSide } );
            // materialRing.transparent = true;
            // materialRing.opacity = 1;
            // meshRing = new THREE.Mesh( geometryRing, materialRing );
            // scene.add( mesh );

            var circleColour = hotspotColour || 0xffff00;
            var geometryCir = new THREE.CircleBufferGeometry(0.15, 32);
            var materialCir = new THREE.MeshPhongMaterial({
                color: hotspotColour,
                side: THREE.DoubleSide
            });
            hotspotGroup = new THREE.Group();
            objectCir = new THREE.Mesh(geometryCir, materialCir);
            objectCir.position.set(-3.125, 1.6, -1.275);
            objectCir.rotation.y = controls.getAzimuthalAngle();

            objectCir.sizeAttenuation = false;
            vLine = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({
                color: 0x142455
            }));
            hLine = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({
                color: 0x142455
            }));
            vLine.position.set(-3.125, 1.6, -1.275);
            hLine.position.set(-3.125, 1.6, -1.275);
            vLine.scale.x = 0.75;
            vLine.scale.y = 0.75;
            hLine.scale.x = 0.75;
            hLine.scale.y = 0.75;
            vLine.rotation.y = controls.getAzimuthalAngle();
            hLine.rotation.y = controls.getAzimuthalAngle();
            objectCir.sizeAttenuation = false;
            vLine.sizeAttenuation = false;
            hLine.sizeAttenuation = false;
            hotspotGroup.sizeAttenuation = false;
            hotspotGroup.add(objectCir);
            hotspotGroup.add(vLine);
            hotspotGroup.add(hLine);
            scene.add(hotspotGroup);

            // hotspotGroup2 = new THREE.Group();
            // objectCir2 = new THREE.Mesh(geometryCir, materialCir);
            // objectCir2.position.set(-2.125, 1.125, -1.785);
            // objectCir2.rotation.y = controls.getAzimuthalAngle();
            // vLine2 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({
            //     color: 0x142455
            // }));
            // hLine2 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({
            //     color: 0x142455
            // }));
            // vLine2.position.set(-2.125, 1.125, -1.785);
            // hLine2.position.set(-2.125, 1.125, -1.785);
            // vLine2.scale.x = 0.75;
            // vLine2.scale.y = 0.75;
            // hLine2.scale.x = 0.75;
            // hLine2.scale.y = 0.75;
            // vLine2.rotation.y = controls.getAzimuthalAngle();
            // hLine2.rotation.y = controls.getAzimuthalAngle();
            // objectCir2.sizeAttenuation = false;
            // vLine2.sizeAttenuation = false;
            // hLine2.sizeAttenuation = false;
            // hotspotGroup2.add(objectCir2);
            // hotspotGroup2.add(vLine2);
            // hotspotGroup2.add(hLine2);
            // // hotspotGroup2.sizeAttenuation = false;
            // scene.add(hotspotGroup2);

            hotspotGroup3 = new THREE.Group();
            objectCir3 = new THREE.Mesh(geometryCir, materialCir);
            objectCir3.position.set(-0.5, 1.375, -1.2);
            objectCir3.rotation.y = controls.getAzimuthalAngle();
            vLine3 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({
                color: 0x142455
            }));
            hLine3 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({
                color: 0x142455
            }));
            vLine3.position.set(-0.5, 1.375, -1.2);
            hLine3.position.set(-0.5, 1.375, -1.2);
            vLine3.scale.x = 0.75;
            vLine3.scale.y = 0.75;
            hLine3.scale.x = 0.75;
            hLine3.scale.y = 0.75;
            vLine3.rotation.y = controls.getAzimuthalAngle();
            hLine3.rotation.y = controls.getAzimuthalAngle();
            objectCir3.sizeAttenuation = false;
            vLine3.sizeAttenuation = false;
            hLine3.sizeAttenuation = false;
            hotspotGroup3.sizeAttenuation = false;
            hotspotGroup3.add(objectCir3);
            hotspotGroup3.add(vLine3);
            hotspotGroup3.add(hLine3);
            scene.add(hotspotGroup3);

            hotspotGroup4 = new THREE.Group();
            objectCir4 = new THREE.Mesh(geometryCir, materialCir);
            objectCir4.position.set(-1.875, 2.125, 1.5);
            objectCir4.rotation.y = controls.getAzimuthalAngle();
            vLine4 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({
                color: 0x142455
            }));
            hLine4 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({
                color: 0x142455
            }));
            vLine4.position.set(-1.875, 2.125, 1.5);
            hLine4.position.set(-1.875, 2.125, 1.5);
            vLine4.scale.x = 0.75;
            vLine4.scale.y = 0.75;
            hLine4.scale.x = 0.75;
            hLine4.scale.y = 0.75;
            vLine4.rotation.y = controls.getAzimuthalAngle();
            hLine4.rotation.y = controls.getAzimuthalAngle();
            objectCir4.sizeAttenuation = false;
            vLine4.sizeAttenuation = false;
            hLine4.sizeAttenuation = false;
            hotspotGroup4.sizeAttenuation = false;
            hotspotGroup4.add(objectCir4);
            hotspotGroup4.add(vLine4);
            hotspotGroup4.add(hLine4);
            hotspotGroup4.position.set(1, -1, 1);
            scene.add(hotspotGroup4);

            hotspotGroup5 = new THREE.Group();
            objectCir5 = new THREE.Mesh(geometryCir, materialCir);
            objectCir5.position.set(1.575, 2.6125, 1.375);
            objectCir5.rotation.y = controls.getAzimuthalAngle();
            vLine5 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({
                color: 0x142455
            }));
            hLine5 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({
                color: 0x142455
            }));
            vLine5.position.set(1.575, 2.6125, 1.375);
            hLine5.position.set(1.575, 2.6125, 1.375);
            vLine5.scale.x = 0.75;
            vLine5.scale.y = 0.75;
            hLine5.scale.x = 0.75;
            hLine5.scale.y = 0.75;
            vLine5.rotation.y = controls.getAzimuthalAngle();
            hLine5.rotation.y = controls.getAzimuthalAngle();
            objectCir5.sizeAttenuation = false;
            vLine5.sizeAttenuation = false;
            hLine5.sizeAttenuation = false;
            hotspotGroup5.sizeAttenuation = false;
            hotspotGroup5.add(objectCir5);
            hotspotGroup5.add(vLine5);
            hotspotGroup5.add(hLine5);
            hotspotGroup5.position.set(1, -1, 1);
            scene.add(hotspotGroup5);

            hotspotGroup6 = new THREE.Group();
            objectCir6 = new THREE.Mesh(geometryCir, materialCir);
            objectCir6.position.set(-0.875, 4.325, 1.375);
            objectCir6.rotation.y = controls.getAzimuthalAngle();
            vLine6 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({
                color: 0x142455
            }));
            hLine6 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({
                color: 0x142455
            }));
            vLine6.position.set(-0.875, 4.325, 1.375);
            hLine6.position.set(-0.875, 4.325, 1.375);
            vLine6.scale.x = 0.75;
            vLine6.scale.y = 0.75;
            hLine6.scale.x = 0.75;
            hLine6.scale.y = 0.75;
            vLine6.rotation.y = controls.getAzimuthalAngle();
            hLine6.rotation.y = controls.getAzimuthalAngle();
            objectCir6.sizeAttenuation = false;
            vLine6.sizeAttenuation = false;
            hLine6.sizeAttenuation = false;
            hotspotGroup6.sizeAttenuation = false;
            hotspotGroup6.add(objectCir6);
            hotspotGroup6.add(vLine6);
            hotspotGroup6.add(hLine6);
            hotspotGroup6.position.set(1, -1, 1);
            scene.add(hotspotGroup6);

            hotspotGroup.cursor = "pointer";
            // hotspotGroup2.cursor = "pointer";
            hotspotGroup3.cursor = "pointer";
            hotspotGroup4.cursor = "pointer";
            hotspotGroup5.cursor = "pointer";
            hotspotGroup6.cursor = "pointer";

            if (postersPopup) {
                hotspotGroup7 = new THREE.Group();
                objectCir7 = new THREE.Mesh(geometryCir, materialCir);
                objectCir7.position.set(-3.225, 2.6125, -2.75);
                objectCir7.rotation.y = controls.getAzimuthalAngle();
                vLine7 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({
                    color: 0x142455
                }));
                hLine7 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({
                    color: 0x142455
                }));
                vLine7.position.set(-3.225, 2.6125, -2.75);
                hLine7.position.set(-3.225, 2.6125, -2.75);
                vLine7.scale.x = 0.75;
                vLine7.scale.y = 0.75;
                hLine7.scale.x = 0.75;
                hLine7.scale.y = 0.75;
                vLine7.rotation.y = controls.getAzimuthalAngle();
                hLine7.rotation.y = controls.getAzimuthalAngle();
                objectCir7.sizeAttenuation = false;
                vLine7.sizeAttenuation = false;
                hLine7.sizeAttenuation = false;
                hotspotGroup7.sizeAttenuation = false;
                hotspotGroup7.add(objectCir7);
                hotspotGroup7.add(vLine7);
                hotspotGroup7.add(hLine7);
                hotspotGroup7.position.set(1, -1, 1);
                scene.add(hotspotGroup7);
                hotspotGroup7.cursor = "pointer";

                hotspotGroup7.on('mouseover', function (event) {
                    $('.tooltip').text('Posters');
                    $('.tooltip').show();
                });
    
                hotspotGroup7.on('mouseout', function (event) {
                    $('.tooltip').hide();
                });

                hotspotGroup7.on('click', function (event) {
                    if (!$('#posters').hasClass('visible')) {
                        $('#posters').addClass('visible');
                    }
                });
                
                hotspotGroup7.on('touchstart', function (event) {
                    if (!$('#posters').hasClass('visible')) {
                        $('#posters').addClass('visible');
                    }
                });
            }
            
            if (jobsPopup) {
                hotspotGroup8 = new THREE.Group();
                objectCir8 = new THREE.Mesh(geometryCir, materialCir);
                objectCir8.position.set(0.25, 1.75, -0.125);
                objectCir8.rotation.y = controls.getAzimuthalAngle();
                vLine8 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.12, 0.015, 0.01), new THREE.MeshBasicMaterial({
                    color: 0x142455
                }));
                hLine8 = new THREE.Mesh(new THREE.BoxBufferGeometry(0.015, 0.12, 0.01), new THREE.MeshBasicMaterial({
                    color: 0x142455
                }));
                vLine8.position.set(0.25, 1.75, -0.125);
                hLine8.position.set(0.25, 1.75, -0.125);
                vLine8.scale.x = 0.75;
                vLine8.scale.y = 0.75;
                hLine8.scale.x = 0.75;
                hLine8.scale.y = 0.75;
                vLine8.rotation.y = controls.getAzimuthalAngle();
                hLine8.rotation.y = controls.getAzimuthalAngle();
                objectCir8.sizeAttenuation = false;
                vLine8.sizeAttenuation = false;
                hLine8.sizeAttenuation = false;
                hotspotGroup8.sizeAttenuation = false;
                hotspotGroup8.add(objectCir8);
                hotspotGroup8.add(vLine8);
                hotspotGroup8.add(hLine8);
                hotspotGroup8.position.set(1, -1, 1);
                scene.add(hotspotGroup8);
                hotspotGroup8.cursor = "pointer";

                hotspotGroup8.on('mouseover', function (event) {
                    $('.tooltip').text('Jobs');
                    $('.tooltip').show();
                });
    
                hotspotGroup8.on('mouseout', function (event) {
                    $('.tooltip').hide();
                });

                hotspotGroup8.on('click', function (event) {
                    if (!$('#jobs').hasClass('visible')) {
                        $('#jobs').addClass('visible');

                        // anime({
                        // 	targets: '#jobs',
                        // 	translateX: ['-101%', '0%'],
                        // 	easing: 'easeInExpo',
                        // 	duration: 500,
                        // 	complete: function(anim) {
                        // 		for (var i = 0; i < anim.animatables.length; i++) {
                        // 			anim.animatables[i].target.style.display = 'none';
                        // 			anim.animatables[i].target.classList.remove('visible');
                        // 		}
                        // 	}
                        // });
                    }
                });
                
                hotspotGroup8.on('touchstart', function (event) {
                    if (!$('#jobs').hasClass('visible')) {
                        $('#jobs').addClass('visible');
                    }
                });
            }

            hotspotGroup.on('mouseover', function (event) {
                $('.tooltip').text('Banner Artwork');
                $('.tooltip').show();
            });
            
            hotspotGroup.on('mouseout', function (event) {
                $('.tooltip').hide();
            });
            
            // hotspotGroup2.on('mouseover', function (event) {
            //     $('.tooltip').text('Posters');
            //     $('.tooltip').show();
            // });
            
            // hotspotGroup2.on('mouseout', function (event) {
            //     $('.tooltip').hide();
            // });
            
            hotspotGroup3.on('mouseover', function (event) {
                $('.tooltip').text('Video');
                $('.tooltip').show();
            });
            
            hotspotGroup3.on('mouseout', function (event) {
                $('.tooltip').hide();
            });
            
            hotspotGroup4.on('mouseover', function (event) {
                $('.tooltip').text('Brochures');
                $('.tooltip').show();
            });

            hotspotGroup4.on('mouseout', function (event) {
                $('.tooltip').hide();
            });
            
            hotspotGroup5.on('mouseover', function (event) {
                $('.tooltip').text('Banner Artwork');
                $('.tooltip').show();
            });

            hotspotGroup5.on('mouseout', function (event) {
                $('.tooltip').hide();
            });
            
            hotspotGroup6.on('mouseover', function (event) {
                $('.tooltip').text('Introduction');
                $('.tooltip').show();
            });

            hotspotGroup6.on('mouseout', function (event) {
                $('.tooltip').hide();
            });

            hotspotGroup.on('touchstart', function (event) {
                if ($('#banner-artwork-2').length > 0) {
                    if (!$('#banner-artwork-2').hasClass('visible')) {
                        $('#banner-artwork-2').addClass('visible');

                        // anime({
                        // 	targets: '#banner-artwork-2',
                        // 	translateX: ['-101%', '0%'],
                        // 	easing: 'easeInExpo',
                        // 	duration: 500,
                        // 	complete: function(anim) {
                        // 		for (var i = 0; i < anim.animatables.length; i++) {
                        // 			anim.animatables[i].target.style.display = 'none';
                        // 			anim.animatables[i].target.classList.remove('visible');
                        // 		}
                        // 	}
                        // });
                    }
                }
            });

            hotspotGroup.on('click', function (event) {
                if ($('#banner-artwork-2').length > 0) {
                    if (!$('#banner-artwork-2').hasClass('visible')) {
                        $('#banner-artwork-2').addClass('visible');
                        // anime({
                        // 	targets: '#brochures',
                        // 	right: '0%',
                        // 	duration: 750,
                        // 	easing: 'easeOutExpo',
                        // 	delay: 0,
                        // 	begin: function(anim) {
                        // 		for (var i = 0; i < anim.animatables.length; i++) {
                        // 			anim.animatables[i].target.style.display = 'block';
                        // 		}
                        // 	},
                        // 	complete: function(anim) {
                        // 		for (var i = 0; i < anim.animatables.length; i++) {
                        // 			anim.animatables[i].target.classList.add('visible');
                        // 			anim.animatables[i].target.style.display = 'block';
                        // 		}
                        // 	}
                        // });
                    }
                }
            });

            $(document).on('click', 'button.close-popup', function (event) {
                event.preventDefault();

                let id = $(this).parent().parent().prop('id');

                if (id === 'popup-3d-tours') {
                    return;
                }

                if ($('#' + id).hasClass('visible')) {
                    $('#' + id).removeClass('visible');
                    // anime({
                    // 	targets: '#' + id,
                    // 	right: '-100%',
                    // 	easing: 'easeInExpo',
                    // 	duration: 500,
                    // 	complete: function(anim) {
                    // 		for (var i = 0; i < anim.animatables.length; i++) {
                    // 			anim.animatables[i].target.style.display = 'none';
                    // 			anim.animatables[i].target.classList.remove('visible');
                    // 		}
                    // 	}
                    // });
                }
            });

            // hotspotGroup2.on('click', function (event) {
            //     if ($('#video').length) {
            //         if (!$('#video').hasClass('visible')) {
            //             $('#video').addClass('visible');
            //         }
            //     }
            // });

            hotspotGroup3.on('touchstart', function (event) {
                if ($('#video').length) {
                    if (!$('#video').hasClass('visible')) {
                        $('#video').addClass('visible');
                    }
                }
            });

            hotspotGroup3.on('click', function (event) {
                if ($('#video').length) {
                    if (!$('#video').hasClass('visible')) {
                        $('#video').addClass('visible');
                        // anime({
                        // 	targets: '#banner-artwork',
                        // 	right: '0%',
                        // 	duration: 750,
                        // 	easing: 'easeOutExpo',
                        // 	delay: 0,
                        // 	begin: function(anim) {
                        // 		for (var i = 0; i < anim.animatables.length; i++) {
                        // 			anim.animatables[i].target.style.display = 'block';
                        // 		}
                        // 	},
                        // 	complete: function(anim) {
                        // 		for (var i = 0; i < anim.animatables.length; i++) {
                        // 			anim.animatables[i].target.classList.add('visible');
                        // 			anim.animatables[i].target.style.display = 'block';
                        // 		}
                        // 	}
                        // });
                    }
                }
            });

            hotspotGroup4.on('touchstart', function (event) {
                if ($('#brochures').length) {
                    if (!$('#brochures').hasClass('visible')) {
                        $('#brochures').addClass('visible');
                    }
                }
            });

            hotspotGroup4.on('click', function (event) {
                if ($('#brochures').length) {
                    if (!$('#brochures').hasClass('visible')) {
                        $('#brochures').addClass('visible');
                    }
                }
            });

            hotspotGroup5.on('touchstart', function (event) {
                if ($('#banner-artwork').length) {
                    if (!$('#banner-artwork').hasClass('visible')) {
                        $('#banner-artwork').addClass('visible');
                    }
                }
            });

            hotspotGroup5.on('click', function (event) {
                if ($('#banner-artwork').length) {
                    if (!$('#banner-artwork').hasClass('visible')) {
                        $('#banner-artwork').addClass('visible');
                    }
                }
            });

            hotspotGroup6.on('touchstart', function (event) {
                if ($('#introduction').length) {
                    if (!$('#introduction').hasClass('visible')) {
                        $('#introduction').addClass('visible');
                    }
                }
            });

            hotspotGroup6.on('click', function (event) {
                if ($('#introduction').length) {
                    if (!$('#introduction').hasClass('visible')) {
                        $('#introduction').addClass('visible');
                    }
                }
            });
        }
    }, function (error) {
        console.error('Error:', error);
    });

    renderer.render(scene, camera);

    function onWindowResize() {
        width = window.innerWidth;
        if (isMicrositeBoothPage) {
            height = window.innerHeight - 112;
        } else {
            height = window.innerHeight;
        }
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
        renderer.setSize(width, height);
        renderer.render(scene, camera);
    }

    window.addEventListener('resize', onWindowResize, false);

    function animate() {
        requestAnimationFrame(animate);

        controls.update();

        renderer.render(scene, camera);
    }

    animate();

    $(document).on('mousemove', function (event) {
        $('.tooltip').css('top', event.clientY)
        $('.tooltip').css('left', event.clientX)
    });

    $(document).on('click', '#expand-menu', function (event) {
        event.preventDefault();

        if ($('#side-nav').hasClass('collapsed')) {
            $('#side-nav').removeClass('collapsed');
        }
    });

    $(document).on('click', '#collapse-menu', function (event) {
        event.preventDefault();

        if (!$('#side-nav').hasClass('collapsed')) {
            $('#side-nav').addClass('collapsed');
        }
    });

    $(document).on('click', '.accordion-item', function(event) {
        event.preventDefault();

        $('.accordion-body').slideUp();
        $(this).find('.accordion-body').slideDown(300);
    });

    $(document).on('click', '#fab-chat', function(event) {
        event.preventDefault();
        $(this).hide();
        $('#chat-popup').addClass('visible');
    });

    $(document).on('click', '#chat-btn', function(event) {
        event.preventDefault();
        $('#fab-chat').hide();
        $('#chat-popup').addClass('visible');
    });

    $(document).on('click', '#greeting_video_toggle', function(event) {
        event.preventDefault();

        $('#greeting-video').addClass('visible');
    });

    var loadedPercentage = 0;
    var counter = 0;
    var target = 0;

    var loaded = false;

    loadingManager.onProgress = function(item, progress, total) {
        var progressBar = document.getElementById('progress');
        var progressText = document.getElementById('progress-text');
        if (progressBar) {
            loadedPercentage = Math.max(loadedPercentage, progress / total * 100);
            target = parseInt(loadedPercentage);
            let difference = Math.max(50, target - counter);
            function animate() {
                if (counter < target) {
                    counter++;
                    progressBar.style.width = counter + '%';
                    if (progressText) {
                        progressText.innerHTML = counter + '<small class="percent__sign">%</small>';
                    }
                } else {
                    clearInterval(id)
                }
            }
            var id = setInterval(animate, 10);
        }
    };
    
    loadingManager.onLoad = function() {
        var loadingScreen = document.getElementById('loading-screen');
        if (loadingScreen) {
            window.setTimeout(function() {
                loadingScreen.style.top = '-100vh';
                loaded = true;

                if (loaded) {
                    window.setTimeout(function() {
                        loadingScreen.style.display = 'none';
                    }, 2000);
                }
            }, 1000);
        }
        
        // var liveChatEnabled = false;
        // console.log('Live Chat enabled initial:', liveChatEnabled);
        // var teamMembersInput = document.getElementById('lc-tmc');
        // console.log('Team members:', teamMembersInput);
        // if (teamMembersInput) {
        //     var totalTeamMember = +teamMembersInput.value;
        //     console.log('Total team member:', totalTeamMember);
        //     if (totalTeamMember > 0) {
        //         liveChatEnabled = true;
        //     }
        // }

        // if (liveChatEnabled) {
        //     var doc = document.head || document.documentElement.head || document.getElementsByTagName('head')[0];
        //     console.log('Doc:', doc);
        //     console.log('Live Chat enabled:', liveChatEnabled);
        
        //     var pusherScript = document.createElement('script');
        //     pusherScript.type = "text/javascript";
        //     pusherScript.onload = function() {
        //         console.log('pusherScript:', pusherScript);
        //         document.head.appendChild(pusherScript);
        //     }
        //     pusherScript.src = 'https://js.pusher.com/5.1/pusher.min.js';
        //     var liveChatScript = document.createElement('script');
        //     liveChatScript.type = "text/javascript";
        //     liveChatScript.onload = function() {
        //         console.log('liveChatScript:', liveChatScript);
        //         document.head.appendChild(liveChatScript);
        //     }
        //     liveChatScript.src = '/js/exhibitions/live-chat.js';
        // }
    };

    // var toggleQualityBtn = document.createElement('button');
    // toggleQualityBtn.className = "change-quality sd";
    // toggleQualityBtn.innerText = "SD";
    
    // var body = document.body || document.documentElement.body || document.getElementsByTagName('body')[0];
    // body.appendChild(toggleQualityBtn);
// });


$(document).on('click', '#expand-menu', function(event) {
    event.preventDefault();

    var timeline = anime.timeline({
        easing: 'easeInOutQuad',
        duration: 500,
        direction: 'normal'
    });

    timeline.add({
        targets: '#side-nav .navigation-content',
        opacity: [1, 0],
        duration: 250,
        delay: 0,
        complete: function(anim) {
            $('#side-nav').css('display', 'none');
        }
    }).add({
        targets: '#side-nav-expanded',
        width: ['120px', '492px'],
        duration: 350,
        // delay: '+=200',
        begin: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'block';
            });
        }
    }, '-=50').add({
        targets: '#side-nav-expanded .navigation-content',
        opacity: [0, 1],
        duration: 300,
        // delay: '+=100',
        // easing: 'easeInOutExpo',
        begin: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'block';
            });
        }
    }, '-=50');

    anime({
        targets: '.content',
        width: '492px',
        easing: 'easeInOutQuad',
        duration: 500,
        delay: 50
    });

    width = window.innerWidth - 492;

    localStorage.setItem('sideMenu', 'false');
});

$(document).on('click', '#collapse-menu', function(event) {
    event.preventDefault();

    var timeline = anime.timeline({
        easing: 'easeInOutQuad',
        direction: 'normal'
    });
    
    timeline.add({
        targets: '#side-nav-expanded .navigation-content',
        opacity: 0,
        duration: 250,
        // delay: '+=200',
        begin: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'block';
            });
        },
        complete: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'none';
            });
        }
    }).add({
        targets: '#side-nav-expanded',
        width: '120px',
        duration: 350,
        begin: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'block';
            });
        },
        complete: function(anim) {
            anim.animatables.forEach(function(item) {
                item.target.style.display = 'none';
            });
        }
    }, '-=75').add({
        targets: '#side-nav .navigation-content',
        opacity: [0, 1],
        duration: 350,
        delay: 0,
        begin: function(anim) {
            $('#side-nav').css('display', 'block');
        }
    }, '-=50');

    var paddingLeft = $('#side-nav').prop('width');
    var offsetWidth = $('#side-nav').prop('offsetWidth');

    anime({
        targets: '.content',
        paddingLeft: paddingLeft,
        easing: 'easeInOutQuad',
        duration: 500,
        delay: 50
    });

    width = window.innerWidth - 120;

    localStorage.setItem('sideMenu', 'true');
});

var iframeInitialised = false,
    galleryInitialised = false,
    _pathname = window.location.pathname;
        
    if (_pathname && _pathname.length > 0) {
        if (_pathname[0] == '/') {
            _pathname = _pathname.replace('/', '');
        }
        
        let _pathnames = _pathname.split('/');
        _pathname = _pathnames[0];
    }

$('.btn-3d-tour').click(function(event) {
    event.preventDefault();

    if ($('#popup-3d-tours').hasClass('visible')) {
        return;
    }

    let _memberId = $('a.btn-tour__card.active').data('id') || $('a.btn-tour__card').first().data('id');
    axios.post('/' + _pathname + '/matterport/' + _memberId);

    anime({
        targets: '#popup-3d-tours',
        translateX: ['-102%', '0%'],
        duration: 750,
        easing: 'easeOutExpo',
        delay: 0,
        begin: function(anim) {
            for (var i = 0; i < anim.animatables.length; i++) {
                anim.animatables[i].target.style.display = 'block';
            }

            if (iframeInitialised) {
                $('#popup-3d-tours iframe').attr('src', $('#popup-3d-tours iframe').attr('data-src'));
            }

            if (!galleryInitialised) {
                if ($('.tours-wrapper .tours-scroll').width() < $('.tours-wrapper .tours-scroll').prop('scrollWidth')) {
                    if ($('.tours-wrapper .tours-scroll').prop('scrollLeft') < 5) {
                        $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-end');
                        $('.tours-wrapper .tours-scroll').parent().addClass('scroll-start');
                    } else if (($('.tours-wrapper .tours-scroll').prop('scrollLeft') + $('.tours-wrapper .tours-scroll').width() + 5) >= $('.tours-wrapper .tours-scroll').prop('scrollWidth')) {
                        $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-start');
                        $('.tours-wrapper .tours-scroll').parent().addClass('scroll-end');
                    } else {
                        $('.tours-wrapper .tours-scroll').parent().addClass('scroll-start');
                        $('.tours-wrapper .tours-scroll').parent().addClass('scroll-end');
                    }
                } else {
                    $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-start');
                    $('.tours-wrapper .tours-scroll').parent().removeClass('scroll-end');
                }
                galleryInitialised = true;
            }
        },
        complete: function(anim) {
            for (var i = 0; i < anim.animatables.length; i++) {
                anim.animatables[i].target.classList.add('visible');
                anim.animatables[i].target.style.display = 'block';
                // Splits text into words and characters
                // $('#popup-3d-tours h1').css('overflow: hidden;');
                const heading = new SplitType('#popup-3d-tours h1', {
                    types: 'chars',
                    absolute: true
                });

                anime({
                    targets: heading.chars,
                    opacity: [0, 1],
                    translateY: [20, 0],
                    duration: 240,
                    easing: 'easeOutExpo',
                    delay: anime.stagger(20)
                });
            }
        }
    });
});

$('#close-3d-tours').click(function(event) {
    event.preventDefault();

    anime({
        targets: '#popup-3d-tours',
        translateX: '-101%',
        easing: 'easeInExpo',
        duration: 500,
        complete: function(anim) {
            for (var i = 0; i < anim.animatables.length; i++) {
                anim.animatables[i].target.style.display = 'none';
                anim.animatables[i].target.classList.remove('visible');
            }

            if (iframeInitialised) {
                $('#popup-3d-tours iframe').attr('src', '');
            }
        }
    });
});

$('a.btn-tour__card').click(function(event) {
    event.preventDefault();
    event.stopPropagation();

    $('a.btn-tour__card').removeClass('active');
    $(this).addClass('active');

    let _src = $(this).data('src').trim();
    $('#popup-3d-tours iframe').attr('src', _src);
    $('#popup-3d-tours iframe').attr('data-src', _src);

    let _memberId = $(this).data('id');
    axios.post('/' + _pathname + '/matterport/' + _memberId);
});

$('.tours-wrapper').imagesLoaded()
    .progress(function(instance, image) {
        if (!image.isLoaded) {
            $(image.img).closest('.tour-item').remove();
        }
    })
    .always(function(instance) {
        $('a.btn-tour__card').first().addClass('active');
        $('#popup-3d-tours iframe').attr('data-src', $('a.btn-tour__card').first().data('src'));
    });

$('#popup-3d-tours iframe').removeAttr('width');
$('#popup-3d-tours iframe').removeAttr('height');
$('#popup-3d-tours iframe').css('width', '100%');
$('#popup-3d-tours iframe').css('height', '100%');
iframeInitialised = true;

let _isMouseDown = false,
    _startX,
    _scrollLeft;

$('.tours-wrapper .tours-scroll').each((index, element) => {
    if ($(element).prop('scrollWidth') > $(element).width()) {
        if ($(element).prop('scrollLeft') > 5) {
            $(element).parent().addClass('scroll-start');
        }

        if (($(element).prop('scrollLeft') + $(element).width()) >= $(element).prop('scrollWidth')) {
            $(element).parent().addClass('scroll-end');
        }
    }

    var tabsList = element;

    $(element).parent().find('.nav-prev').on('mousedown', function(event) {
        event.preventDefault();
        $(tabsList).animate({
            scrollLeft: $(tabsList).prop('scrollLeft') - (Math.floor(($('.tours-wrapper').width() + 120) / ($('.tour-item').width() + 16)) * ($('.tour-item').width() + 16))
        }, 350);
    });
    
    $(element).parent().find('.nav-next').on('mousedown', function(event) {
        event.preventDefault();
        $(tabsList).animate({
            scrollLeft: $(tabsList).prop('scrollLeft') + (Math.floor(($('.tours-wrapper').width() + 120) / ($('.tour-item').width() + 16)) * ($('.tour-item').width() + 16))
        }, 350);
    });
});

$('.tours-wrapper .tours-scroll').on('scroll', function(event) {
    if ($(this).prop('scrollLeft') < 5) {
        $(this).parent().removeClass('scroll-end');
        $(this).parent().addClass('scroll-start');
    } else if (($(this).prop('scrollLeft') + $(this).width() + 125) >= $(this).prop('scrollWidth')) {
        $(this).parent().removeClass('scroll-start');
        $(this).parent().addClass('scroll-end');
    } else {
        $(this).parent().addClass('scroll-start');
        $(this).parent().addClass('scroll-end');
    }
});

$('.tours-wrapper .tours-scroll').on('mousedown', function(event) {
    _isMouseDown = true;
    _startX = event.pageX - $('.tours-wrapper .tours-scroll').offset().left;
    _scrollLeft = $('.tours-wrapper .tours-scroll').scrollLeft();
});

$('.tours-wrapper .tours-scroll').on('mouseleave', function(event) {
    _isMouseDown = false;
});

$('.tours-wrapper .tours-scroll').on('mouseup', function(event) {
    _isMouseDown = false;
});

$('.tours-wrapper .tours-scroll').on('mousemove', function(event) {
    event.preventDefault();
    if (!_isMouseDown) return;
    else event.stopPropagation();
    let _x = event.pageX - $('.tours-wrapper .tours-scroll').offset().left;
    let _walk = _x - _startX;
    $('.tours-wrapper .tours-scroll').scrollLeft(_scrollLeft - _walk);
});